interface WelcomeEmailProps {
  firstName: string;
  email: string;
  password: string;
}

const PLATFORM_NAME = 'CherryMarket / FruitMarkets';

/**
 * Genera el HTML para el email de bienvenida
 * @param firstName - Nombre del usuario
 * @param email - Email del usuario
 * @param password - Contraseña del usuario
 * @returns HTML string para el email
 */
export const generateWelcomeEmail = ({
  firstName,
  email,
  password,
}: WelcomeEmailProps): string => {
  return `
    <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px; border: 1px solid #e0e0e0; border-radius: 8px;">
      <h2 style="color: #BE123C; text-align: center; margin-bottom: 20px;">¡Bienvenido a ${PLATFORM_NAME}!</h2>
      <p style="margin-bottom: 15px;">Hola ${firstName},</p>
      <p style="margin-bottom: 15px;">Tu cuenta de ${PLATFORM_NAME} ha sido creada exitosamente. Ahora puedes acceder a la plataforma con tus credenciales:</p>
      <div style="background-color: #f8f8f8; padding: 15px; border-radius: 6px; margin-bottom: 20px;">
        <p style="margin-bottom: 10px;"><strong>Email:</strong> ${email}</p>
        <p style="margin-bottom: 10px;"><strong>Contraseña:</strong> ${password}</p>
      </div>
      <div style="text-align: center; margin-bottom: 20px;">
        <a href="https://portal.cherrymarket.cl" style="background-color: #BE123C; color: white; padding: 10px 20px; text-decoration: none; border-radius: 4px; font-weight: bold;">Iniciar sesión en ${PLATFORM_NAME}</a>
      </div>
      <p style="margin-bottom: 15px;">Si tienes alguna pregunta o necesitas asistencia, por favor contacta a tu administrador.</p>
      <hr style="border: none; border-top: 1px solid #e0e0e0; margin: 20px 0;">
      <p style="color: #666; font-size: 12px; text-align: center;">${PLATFORM_NAME} &copy; ${new Date().getFullYear()} - Todos los derechos reservados</p>
    </div>
  `;
};
